export enum VisionDateFormatType {
  US = 'us',
  TR = 'tr',
}
